export const eventMock = {
  columns: [
    {
      label: "Event description",
      key: "EventDescription",
      idTh: "firstTh",
      idTd: "firstTd",
    },
    {
      label: "Event date",
      key: "EventDate",
      idTh: "firstTh",
      idTd: "firstTd",
    },
    {
      label: "Origin",
      key: "Origin",
      idTh: "firstTh",
      idTd: "firstTd",
    },
    {
      label: "Update date",
      key: "CreateDate",
      idTh: "firstTh",
      idTd: "firstTd",
    },

  ],
  tables: [
    {
      columns: [
        {
          label: "Descripción del Evento",
          key: "Descripcion",
          idTh: "firstTh",
          idTd: "firstTd",
        },
        {
          label: "Fecha del Evento",
          key: "Fecha",
          idTh: "firstTh",
          idTd: "firstTd",
        },
        /* {
          label: "Categoría de Responsable",
          key: "Categoria",
          idTh: "firstTh",
          idTd: "firstTd",
        },
        { label: "Origen", key: "Nombre", idTh: "firstTh", idTd: "firstTd" },
        {
          label: "Fecha de Creación",
          key: "FechaActualizacion",
          idTh: "firstTh",
          idTd: "firstTd",
        }, */
      ],
      data: [],
      title: "Reserva",
    },
    {
      columns: [
        {
          label: "Descripción del Evento",
          key: "Descripcion",
          idTh: "firstTh",
          idTd: "firstTd",
        },
        {
          label: "Fecha del Evento",
          key: "Fecha",
          idTh: "firstTh",
          idTd: "firstTd",
        },
        /* {
          label: "Categoría de Responsable",
          key: "Categoria",
          idTh: "firstTh",
          idTd: "firstTd",
        },
        { label: "Origen", key: "Nombre", idTh: "firstTh", idTd: "firstTd" },
        {
          label: "Fecha de Creación",
          key: "FechaActualizacion",
          idTh: "firstTh",
          idTd: "firstTd",
        }, */
      ],
      data: [],
      title: "Embarques de Exportación",
    },
    {
      columns: [
        {
          label: "Descripción del Evento",
          key: "Descripcion",
          idTh: "firstTh",
          idTd: "firstTd",
        },
        {
          label: "Fecha del Evento",
          key: "Fecha",
          idTh: "firstTh",
          idTd: "firstTd",
        },
        /* {
          label: "Categoría de Responsable",
          key: "Categoria",
          idTh: "firstTh",
          idTd: "firstTd",
        },
        { label: "Origen", key: "Nombre", idTh: "firstTh", idTd: "firstTd" },
        {
          label: "Fecha de Creación",
          key: "FechaActualizacion",
          idTh: "firstTh",
          idTd: "firstTd",
        }, */
      ],
      data: [],
      title: "Embarques de Importación",
    },
  ],
};